/* eslint-disable max-lines */
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdStylioCapsule3 } from './pages'

type TIdToPageMapStylioCapsule3 = Record<PageIdStylioCapsule3, TPageMapValue>

export const ID_TO_PAGE_MAP_STYLIO_CAPSULE3: TIdToPageMapStylioCapsule3 = {
  [PageIdStylioCapsule3.AGE_CAPSULE3]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule3/pages/questions/AgeQuestion').then(
        (m) => ({
          default: m.AgeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs2/pages/questions/AgeQuestion'),
  },
  [PageIdStylioCapsule3.URGE_CAPSULE3]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule3/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_capsule3/pages/urge/UrgePage'),
  },
  [PageIdStylioCapsule3.HAIR_COLOR_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/questions/HairColorQuestion'
      ).then((m) => ({
        default: m.HairColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule3/pages/questions/HairColorQuestion'),
  },
  [PageIdStylioCapsule3.EYES_COLOR_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/questions/EyesColorQuestion'
      ).then((m) => ({
        default: m.EyesColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule3/pages/questions/EyesColorQuestion'),
  },
  [PageIdStylioCapsule3.JEWELRY_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/questions/JewelryQuestion'
      ).then((m) => ({
        default: m.JewelryQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule3/pages/questions/JewelryQuestion'),
  },
  [PageIdStylioCapsule3.BODY_SHAPE_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/questions/BodyShapeQuestion'
      ).then((m) => ({
        default: m.BodyShapeQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule3/pages/questions/BodyShapeQuestion'),
  },
  [PageIdStylioCapsule3.STYLIO_TO_HELP_CAPSULE3]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule3/pages/questions/StylioToHelp').then(
        (m) => ({
          default: m.StylioToHelp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule3/pages/questions/StylioToHelp'),
  },
  [PageIdStylioCapsule3.TALL_CAPSULE3]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule3/pages/questions/TallQuestion').then(
        (m) => ({
          default: m.TallQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule3/pages/questions/TallQuestion'),
  },
  [PageIdStylioCapsule3.WEIGHT_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/questions/WeightQuestion'
      ).then((m) => ({
        default: m.WeightQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule3/pages/questions/WeightQuestion'),
  },
  [PageIdStylioCapsule3.URGE_2_CAPSULE3]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule3/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule3/pages/urge/UrgePageVariant2'),
  },
  [PageIdStylioCapsule3.FEEL_ABOUT_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/questions/FeelAboutQuestion'
      ).then((m) => ({
        default: m.FeelAboutQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule3/pages/questions/FeelAboutQuestion'),
  },
  [PageIdStylioCapsule3.PERCENTAGE_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/questions/PercentageQuestion'
      ).then((m) => ({
        default: m.PercentageQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/questions/PercentageQuestion'
      ),
  },
  [PageIdStylioCapsule3.SHOPPING_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/questions/ShoppingQuestion'
      ).then((m) => ({
        default: m.ShoppingQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule3/pages/questions/ShoppingQuestion'),
  },
  [PageIdStylioCapsule3.STYLE_MOST_MATTERS_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/questions/StyleMostMattersQuestion'
      ).then((m) => ({
        default: m.StyleMostMattersQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/questions/StyleMostMattersQuestion'
      ),
  },
  [PageIdStylioCapsule3.FAVORITE_COLORS_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/questions/FavoriteColorsQuestion'
      ).then((m) => ({
        default: m.FavoriteColorsQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/questions/FavoriteColorsQuestion'
      ),
  },
  [PageIdStylioCapsule3.LIKE_OR_DISLIKE_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/likeOrDislike/LikeOrDislike'
      ).then((m) => ({
        default: m.LikeOrDislikeQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule3/pages/likeOrDislike/LikeOrDislike'),
  },
  [PageIdStylioCapsule3.LIKE_OR_DISLIKE_11_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/likeOrDislike/LikeOrDislikeVariant11'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant11Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/likeOrDislike/LikeOrDislikeVariant11'
      ),
  },
  [PageIdStylioCapsule3.LIKE_OR_DISLIKE_12_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/likeOrDislike/LikeOrDislikeVariant12'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant12Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/likeOrDislike/LikeOrDislikeVariant12'
      ),
  },
  [PageIdStylioCapsule3.LIKE_OR_DISLIKE_13_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/likeOrDislike/LikeOrDislikeVariant13'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant13Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/likeOrDislike/LikeOrDislikeVariant13'
      ),
  },
  [PageIdStylioCapsule3.LIKE_OR_DISLIKE_14_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/likeOrDislike/LikeOrDislikeVariant14'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant14Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/likeOrDislike/LikeOrDislikeVariant14'
      ),
  },
  [PageIdStylioCapsule3.LIKE_OR_DISLIKE_15_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/likeOrDislike/LikeOrDislikeVariant15'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant15Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/likeOrDislike/LikeOrDislikeVariant15'
      ),
  },
  [PageIdStylioCapsule3.LIKE_OR_DISLIKE_16_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/likeOrDislike/LikeOrDislikeVariant16'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant16Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/likeOrDislike/LikeOrDislikeVariant16'
      ),
  },
  [PageIdStylioCapsule3.LIKE_OR_DISLIKE_17_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/likeOrDislike/LikeOrDislikeVariant17'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant17Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/likeOrDislike/LikeOrDislikeVariant17'
      ),
  },
  [PageIdStylioCapsule3.LIKE_OR_DISLIKE_18_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/likeOrDislike/LikeOrDislikeVariant18'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant18Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/likeOrDislike/LikeOrDislikeVariant18'
      ),
  },
  [PageIdStylioCapsule3.LIKE_OR_DISLIKE_19_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/likeOrDislike/LikeOrDislikeVariant19'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant19Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/likeOrDislike/LikeOrDislikeVariant19'
      ),
  },
  [PageIdStylioCapsule3.STYLES_FEEL_LIKE_YOU_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/questions/StylesFeelLikeYouQuestion'
      ).then((m) => ({
        default: m.StylesFeelLikeYouQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/questions/StylesFeelLikeYouQuestion'
      ),
  },
  [PageIdStylioCapsule3.URGE_3_CAPSULE3]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule3/pages/urge/UrgePageVariant3').then(
        (m) => ({
          default: m.UrgePageVariant3,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule3/pages/urge/UrgePageVariant3'),
  },
  [PageIdStylioCapsule3.BRAND_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/questions/BrandQuestion'
      ).then((m) => ({
        default: m.BrandQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule3/pages/questions/BrandQuestion'),
  },
  [PageIdStylioCapsule3.FIND_NEW_CLOTHES_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/questions/FindNewClothesQuestion'
      ).then((m) => ({
        default: m.FindNewClothesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/questions/FindNewClothesQuestion'
      ),
  },
  [PageIdStylioCapsule3.NOTHING_TO_WEAR_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/questions/NothingToWearQuestion'
      ).then((m) => ({
        default: m.NothingToWearQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/questions/NothingToWearQuestion'
      ),
  },
  [PageIdStylioCapsule3.OLD_CLOTHES_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/questions/OldClothesQuestion'
      ).then((m) => ({
        default: m.OldClothesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/questions/OldClothesQuestion'
      ),
  },
  [PageIdStylioCapsule3.COMBINE_CLOTHES_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/questions/CombineClothesQuestion'
      ).then((m) => ({
        default: m.CombineClothesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/questions/CombineClothesQuestion'
      ),
  },
  [PageIdStylioCapsule3.OPTIMIZE_BUDGET_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/questions/OptimizeBudgetQuestion'
      ).then((m) => ({
        default: m.OptimizeBudgetQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/questions/OptimizeBudgetQuestion'
      ),
  },
  [PageIdStylioCapsule3.URGE_4_CAPSULE3]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule3/pages/urge/UrgePageVariant4').then(
        (m) => ({
          default: m.UrgePageVariant4,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule3/pages/urge/UrgePageVariant4'),
  },
  [PageIdStylioCapsule3.PREPARE_FLOW_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/prepareFlow/PrepareFlow'
      ).then((m) => ({
        default: m.PrepareFlow,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule3/pages/prepareFlow/PrepareFlow'),
  },
  [PageIdStylioCapsule3.EMAIL_CAPSULE3]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule3/pages/email/Email').then((m) => ({
        default: m.Email,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_capsule3/pages/email/Email'),
  },
  [PageIdStylioCapsule3.EMAIL_CONSENT_CAPSULE3]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule3/pages/email/EmailConsent').then(
        (m) => ({
          default: m.EmailConsent,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule3/pages/email/EmailConsent'),
  },
  [PageIdStylioCapsule3.SUBSCRIPTIONS_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/subscriptions/SubscriptionPage'
      ).then((m) => ({
        default: m.SubscriptionPage,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/subscriptions/SubscriptionPage'
      ),
  },
  [PageIdStylioCapsule3.CANCEL_OFFER_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/cancel-offer/CancelOffer'
      ).then((m) => ({
        default: m.CancelOffer,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule3/pages/cancel-offer/CancelOffer'),
  },
  [PageIdStylioCapsule3.SUB_UPSELL_CAPSULE3]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule3/pages/sub-upsell/SubUpsell').then(
        (m) => ({
          default: m.SubUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule3/pages/sub-upsell/SubUpsell'),
  },
  [PageIdStylioCapsule3.UPSELL_CAPSULE3]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule3/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_capsule3/pages/upsell/Upsell'),
  },
  [PageIdStylioCapsule3.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
  [PageIdStylioCapsule3.DOWNLOAD_CAPSULE3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/download-app/DownloadDefault'
      ).then((m) => ({
        default: m.DownloadDefault,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule3/pages/download-app/DownloadDefault'
      ),
  },
}
